import * as React from 'react'
import { useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import EditLocationWorkplaceForm from 'modules/locations/components/LocationWorkplacesForms/Edit/index'
import type Location from 'modules/locations/store/models/Location'

const WorkplaceDetailsComponent = ({ children }: React.PropsWithChildren) => {
  const { location } = useOutletContext<{ location: Location }>()

  return (
    <ResponsivePage.Body variant="narrow" showHeader={false}>
      {children}
      <EditLocationWorkplaceForm locationId={location.id} />
    </ResponsivePage.Body>
  )
}

export default WorkplaceDetailsComponent
